import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { CertEmailComponent } from '../../../components/cert';
import useCommonStore from '../../../hooks/useCommonStore';
import useUsersStore from '../../../hooks/useUsersStore';

const EmailAuth = observer(({ history, location }) => {
  const commonStore = useCommonStore();
  const usersStore = useUsersStore();
  const resultPath = 'mypage/email_auth';
  const [isToken, setIsToken] = useState(false);

  const onEmailCertifyToken = (token) => {
    commonStore
      .actionMyCertifyEmailToken({ token })
      .then(() => {
        history.replace('/mypage/info');
      });
    setIsToken(true);
  };

  return (
    <>
      {!isToken && (
        <CertEmailComponent
          email={usersStore.data.email}
          resultPath={resultPath}
          readOnly={true}
          history={history}
          sendCertifyToken={onEmailCertifyToken}
        />
      )}
    </>
  );
});

export default EmailAuth;
